/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merry_Minor_Mare_AscendInputs */

const fr_merry_minor_mare_ascend = /** @type {(inputs: Merry_Minor_Mare_AscendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bannière de la home`)
};

/**

* @param {Merry_Minor_Mare_AscendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const merry_minor_mare_ascend = /** @type {((inputs?: Merry_Minor_Mare_AscendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merry_Minor_Mare_AscendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_merry_minor_mare_ascend(inputs)
});